import { render, staticRenderFns } from "./get-sa-id.page.vue?vue&type=template&id=76b5e97c&"
import script from "./get-sa-id.page.vue?vue&type=script&lang=ts&"
export * from "./get-sa-id.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports